/* eslint-disable react/prop-types */
// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
import React from "react"
import { FaCheck, FaTimes } from "react-icons/fa"
import styled from "styled-components"
import { NavLink } from "react-router-dom"
// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

export default function EdtCardFull({ edt, className = "" }) {
    return (
        <StyledContainer
            className={"row col-sm-12 col-md-4 col-lg-3 col-xl-2 " + className}
            to={"/edt/" + edt.id + "/postages"}
        >
            <div className={"edtItem " + (!edt.actif && " bg-secondary ")}>
                <NavLink
                    className="card-headerX"
                    to={"/edt/" + edt.id + "/postages"}
                >
                    <h6>-{edt.etablissement.nom}-</h6>
                    <h5>
                        {edt.nom}{" "}
                        {edt.actif === true && (
                            <FaCheck
                                className="text-success"
                                title="EDT actif"
                            />
                        )}
                        {edt.actif === false && (
                            <span className="text-danger" title="EDT inactif">
                                EDT inactif <FaTimes />
                            </span>
                        )}
                    </h5>

                    {edt.description && (
                        <div className="card-body">
                            <div className="card-text">{edt.description}</div>
                        </div>
                    )}
                </NavLink>
            </div>
        </StyledContainer>
    )
}

// 〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓	STYLED_COMPONENTS

const StyledContainer = styled.div`
    padding: 5px;

    .edtItem {
        text-decoration: none;
        border: 1px solid #0b5b95;
        min-height: 60px;
        display: flex;
        text-align: center;
        padding: 5px;
        a {
            text-decoration: none;
            align-self: center;
            width: 100%;
        }
        &:hover {
            a {
                color: white;
            }

            background-color: #0b5b95;
        }

        .card-header {
            border-bottom: 1px solid #0b5b95;
        }
    }
`
